/**
 * @fileoverview Utility functions for time-related operations
 */

import { DEFAULT_DEADLINE } from "../constants";

/**
 * Calculates a deadline timestamp in seconds from the current time
 *
 * @param {number} [daysFromNow=DEFAULT_DEADLINE] - Number of days from now to set the deadline
 * @returns {number} Unix timestamp in seconds representing the deadline
 *
 * @example
 * // Returns a timestamp 3 days from now (in seconds)
 * const threeDay = calculateDeadline();
 *
 * @example
 * // Returns a timestamp 7 days from now (in seconds)
 * const weekDeadline = calculateDeadline(7);
 */
export const calculateDeadline = (daysFromNow = DEFAULT_DEADLINE) => {
  // Get days in seconds
  const daysInSeconds = daysFromNow * 24 * 60 * 60;

  // Get current timestamp in seconds
  const currentTimeStamp = Math.floor(Date.now() / 1000);

  // Calculate deadline (current time + 3 days in seconds)
  const deadline = currentTimeStamp + daysInSeconds;

  return BigInt(deadline);
};
